<template>
	<div class="sky-phone-areaCode">
		<el-input
			placeholder="请输入手机号码"
			@change="inputChange"
			@input="input"
			v-model="inputValue"
		>
			<template slot="prepend">
				<el-select placeholder="区号" @change="selectChange" v-model="selectValue">
					<el-option
						v-for="item in options"
						:key="item.value"
						:label="item.code"
						:value="item.code"
					>
						<span>{{ `${item.name}(${item.code})` }}</span>
					</el-option>
				</el-select>
			</template>
		</el-input>
	</div>
</template>

<script>
export default {
	name: 'sky-phone-areaCode',
	props: {
		value: {
			default: null,
			required: true,
		},
	},
	data() {
		return {
			options: [
				{ name: '中国', code: '+86', flag: '🇨🇳' },
				{ name: '日本', code: '+81', flag: '🇯🇵' },
				{ name: '韩国', code: '+82', flag: '🇰🇷' },
				{ name: '印度', code: '+91', flag: '🇮🇳' },
				{ name: '印度尼西亚', code: '+62', flag: '🇮🇩' },
				{ name: '马来西亚', code: '+60', flag: '🇲🇾' },
				{ name: '新加坡', code: '+65', flag: '🇸🇬' },
				{ name: '泰国', code: '+66', flag: '🇹🇭' },
				{ name: '菲律宾', code: '+63', flag: '🇵🇭' },
				{ name: '越南', code: '+84', flag: '🇻🇳' },
				{ name: '英国', code: '+44', flag: '🇬🇧' },
				{ name: '德国', code: '+49', flag: '🇩🇪' },
				{ name: '法国', code: '+33', flag: '🇫🇷' },
				{ name: '意大利', code: '+39', flag: '🇮🇹' },
				{ name: '西班牙', code: '+34', flag: '🇪🇸' },
				{ name: '俄罗斯', code: '+7', flag: '🇷🇺' },
				{ name: '荷兰', code: '+31', flag: '🇳🇱' },
				{ name: '瑞士', code: '+41', flag: '🇨🇭' },
				{ name: '瑞典', code: '+46', flag: '🇸🇪' },
				{ name: '丹麦', code: '+45', flag: '🇩🇰' },
				{ name: '美国', code: '+1', flag: '🇺🇸' },
				{ name: '加拿大', code: '+1', flag: '🇨🇦' },
				{ name: '墨西哥', code: '+52', flag: '🇲🇽' },
				{ name: '古巴', code: '+53', flag: '🇨🇺' },
				{ name: '巴西', code: '+55', flag: '🇧🇷' },
				{ name: '阿根廷', code: '+54', flag: '🇦🇷' },
				{ name: '智利', code: '+56', flag: '🇨🇱' },
				{ name: '秘鲁', code: '+51', flag: '🇵🇪' },
				{ name: '哥伦比亚', code: '+57', flag: '🇨🇴' },
				{ name: '委内瑞拉', code: '+58', flag: '🇻🇪' },
				{ name: '南非', code: '+27', flag: '🇿🇦' },
				{ name: '埃及', code: '+20', flag: '🇪🇬' },
				{ name: '尼日利亚', code: '+234', flag: '🇳🇬' },
				{ name: '肯尼亚', code: '+254', flag: '🇰🇪' },
				{ name: '坦桑尼亚', code: '+255', flag: '🇹🇿' },
				{ name: '摩洛哥', code: '+212', flag: '🇲🇦' },
				{ name: '澳大利亚', code: '+61', flag: '🇦🇺' },
				{ name: '新西兰', code: '+64', flag: '🇳🇿' },
				{ name: '巴布亚新几内亚', code: '+675', flag: '🇵🇬' },
				{ name: '斐济', code: '+679', flag: '🇫🇯' },
			],
			selectValue: '',
			inputValue: '',
		};
	},
	watch: {
		value: {
			handler(val) {
				let [code, value] = val.split(' ');
				this.inputValue = value || '';
				this.selectValue = code || '+86';
			},
			immediate: true,
		},
	},
	methods: {
		inputChange() {
			let { inputValue, selectValue } = this;
			let val = `${selectValue} ${inputValue}`;
			this.$emit('input', val);
		},
		input() {
			let { inputValue, selectValue } = this;
			let val = `${selectValue} ${inputValue}`;
			this.$emit('input', val);
		},
		selectChange() {
			let { inputValue, selectValue } = this;
			let val = `${selectValue} ${inputValue}`;
			this.$emit('input', val);
		},
	},
};
</script>

<style lang="scss" scoped>
.sky-phone-areaCode {
	::v-deep .el-input {
		.el-input-group__prepend {
			width: 90px;
		}
	}
}
</style>
